export const layoutTheme = {
  padding: "py-8 px-8 lg:px-24",
};
export const marketingLayoutTheme = {
  padding: "px-8", // 2rem horizontal padding on parent section
};
